import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgStyle } from '@angular/common';

export type IceBadgeType =
  'regular' | 'error' | 'critical' | 'success' | 'warning' | 'neutral' | 'info' | 'info-light' | 'transparent' | 'disabled';

@Component({
  selector: 'app-ice-badge',
  templateUrl: './ice-badge.component.html',
  styleUrls: ['./ice-badge.component.scss'],
  imports: [NgClass, NgStyle, MatIcon],
})
export class IceBadgeComponent {
  @Input() type: IceBadgeType = 'regular';
  @Input() borderRadius: string = '2px';
  @Input() icon: string = '';
  @Input() fontSize: string;
  @Input() padding: string;
}
